import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from '@components/Layout';
import Colors from '@components/shared/Colors';
import { NAVBAR_HEIGHT } from '@constants';
import { VitalsAuthorNode } from '@contracts';
import AuthorData from '../components/AuthorData';

export const pageQuery = graphql`
  query Authors($id: String!, $language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    prismicVitalsAuthors(id: { eq: $id }) {
      id
      uid
      url
      first_publication_date
      tags
      data {
        meta_description
        meta_title
        meta_image {
          url
        }
        name
        title
        professional_title
        author_bio {
          text
          richText
        }
        image {
          alt
          gatsbyImageData
          url
        }
        tags {
          tag
        }
        can_book_consultations
      }
    }
  }
`;

interface Props {
  data: {
    prismicVitalsAuthors: VitalsAuthorNode;
  };
}

const AuthorPage: React.FC<Props> = ({ data }) => {
  const { prismicVitalsAuthors } = data;

  const { uid, url, data: authorData } = prismicVitalsAuthors;
  const { meta_description, meta_title, meta_image, name } = authorData;

  const SEO = {
    uid,
    href: url,
    title: meta_title || name || '',
    image: meta_image?.url,
    description: meta_description || '',
    authorData
  };

  return (
    <Layout SEO={SEO}>
      <AuthorPageContainer>
        <AuthorDetails>
          <AuthorData author={prismicVitalsAuthors} />
        </AuthorDetails>
      </AuthorPageContainer>
    </Layout>
  );
};

export default AuthorPage;

const AuthorPageContainer = styled.div`
  margin: 0;
  margin-top: ${NAVBAR_HEIGHT}px;
  height: auto;
  width: 100%;
  transition: opacity 0.5s ease-in, visibility 0.1s ease-in;
  background-color: ${Colors.cream};
  color: ${Colors.navyBlue};
`;

const AuthorDetails = styled.div``;
